/* Töpferkunst Rahmen 2.0 – „Mehr laden" auf Kategorieseiten.
   Holt die nächste Seite per fetch(url + section_id) (Shopify Section Rendering API), hängt die
   Produktkarten (#product-grid > li) an, ersetzt den Steuerblock (#tk-load-more) durch den der neuen Seite
   und führt die URL per history.replaceState mit. Automatisches Nachladen beim Scrollen über
   IntersectionObserver (data-auto="true"). Nach Filter-/Sortierwechsel ersetzt facets.js den
   #ProductGridContainer – ein MutationObserver bindet den Beobachter dann neu.
   Wird nur von sections/main-collection-product-grid.liquid geladen. */
(function () {
  'use strict';
  if (window.tkLoadMoreInit) return;
  window.tkLoadMoreInit = true;

  var loading = false;
  var io = null;

  function ctl() { return document.getElementById('tk-load-more'); }

  function setBusy(c, busy) {
    if (!c) return;
    c.classList.toggle('is-loading', busy);
    var btn = c.querySelector('.tk-load-more__btn');
    if (btn) btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function showError(c) {
    if (!c) return;
    var err = c.querySelector('.tk-load-more__error');
    if (err) err.hidden = false;
  }

  function cancelAnimation(el) {
    if (el.classList.contains('scroll-trigger')) el.classList.add('scroll-trigger--cancel');
    el.querySelectorAll('.scroll-trigger').forEach(function (e) { e.classList.add('scroll-trigger--cancel'); });
  }

  function load(focusFirst) {
    var c = ctl();
    if (!c || loading) return;
    var next = c.getAttribute('data-next-url');
    if (!next) return;
    loading = true;
    setBusy(c, true);
    var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(c.getAttribute('data-section-id') || '');

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var grid = document.getElementById('product-grid');
        var firstNew = null;
        if (newGrid && grid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (li) {
            cancelAnimation(li);
            grid.appendChild(li);
            if (!firstNew) firstNew = li;
          });
        }
        var current = ctl();
        var fresh = doc.getElementById('tk-load-more');
        if (current) {
          if (fresh) current.replaceWith(fresh); else current.remove();
        }
        var fb = document.querySelector('.tk-pagination-fallback');
        var freshFb = doc.querySelector('.tk-pagination-fallback');
        if (fb) { if (freshFb) fb.replaceWith(freshFb); else fb.remove(); }

        try { history.replaceState(history.state, '', next); } catch (e) { /* egal */ }

        if (focusFirst && firstNew) {
          var link = firstNew.querySelector('a');
          if (link) link.focus({ preventScroll: true });
        }
        loading = false;
        observe();
      })
      .catch(function () {
        loading = false;
        var c2 = ctl();
        setBusy(c2, false);
        showError(c2);
      });
  }

  function observe() {
    if (io) { io.disconnect(); io = null; }
    var c = ctl();
    if (!c || c.getAttribute('data-auto') !== 'true' || !c.getAttribute('data-next-url')) return;
    if (!('IntersectionObserver' in window)) return;
    var sentinel = c.querySelector('.tk-load-more__sentinel');
    if (!sentinel) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) load(false); });
    }, { rootMargin: '600px 0px' });
    io.observe(sentinel);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.tk-load-more__btn');
    if (!btn) return;
    e.preventDefault();
    load(true);
  });

  function boot() {
    observe();
    var container = document.getElementById('ProductGridContainer');
    if (container && 'MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(observe, 50);
      }).observe(container, { childList: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
